"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MailNotificationType;
(function (MailNotificationType) {
    MailNotificationType["liberated"] = "liberated";
    MailNotificationType["reviewing"] = "reviewing";
    MailNotificationType["liberatedWithDelay"] = "liberatedWithDelay";
})(MailNotificationType || (MailNotificationType = {}));
exports.default = MailNotificationType;
